export default __webpack_public_path__ + "static/media/Porco - Corral.78e0fcfe.png";